/* prettier-ignore */

import { Component, Input, ViewEncapsulation} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PDFViewerComponent } from '../pdf-viewer/pdf-viewer.page';
import { Router } from '@angular/router';
import { IDatasource } from 'ngx-ui-scroll';

@Component({
  selector: 'cicerone-list-cards',
  templateUrl: './list-cards.component.html',
  styleUrls: ['./list-cards.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class ListCardsComponent {
  @Input() item?: any;

  datasource: IDatasource = {
    get: (index, count, success) => {
      const data = [];
      for (let i = index; i <= index + count - 1; i++) {
        if (this.item?.items?.length > i)
          data.push({type: 'item', data: this.item.items[i]});
        // else if (this.item?.items?.length === i)
        //   data.push({type: 'more', data: []})
      }
      success(data);
    },
    settings: {
      horizontal: true,
      minIndex: 0,
      startIndex: 0
    }
  };

  constructor(
    public translate: TranslateService, 
    public modalCtrl: ModalController, 
    private router: Router,
  ) {}

  async openModalPDF(pdf){
    const modal = await this.modalCtrl.create({
      component: PDFViewerComponent,
      cssClass: ['pdfModal', 'ion-disable-focus-trap'],
      componentProps: { pdf: pdf.url[this.translate.currentLang], name: pdf.name[this.translate.currentLang], id: pdf.id }
    });
    await modal.present();
  }

  goToSubCategoriesList(item){
    this.router.navigate([`/${item.nameSlug[this.translate.currentLang]}/${item.id}`]);
  }

}